import LegalLayout from "./LegalLayout";

export default function TermsOfService() {
  return (
    <LegalLayout title="Terms of Service" lastUpdated="April 21, 2026">
      <p>
        These Terms of Service ("Terms") govern your access to and use of
        LegacyGrowth Engine ("Service") provided by H&amp;E Associates LLC
        ("we", "us"). By creating an account or using the Service, you agree to
        these Terms. If you are accepting on behalf of an organization, you
        represent that you are authorized to bind that organization.
      </p>

      <h2>1. Account &amp; eligibility</h2>
      <p>
        You must be 18+ and able to form a binding contract. You are
        responsible for activity under your account and for keeping credentials
        secure. Notify us immediately at{" "}
        <a href="mailto:security@legacygrowthengine.com">security@legacygrowthengine.com</a>{" "}
        of any unauthorized access.
      </p>

      <h2>2. Subscriptions, trials &amp; billing</h2>
      <ul>
        <li>Plans, prices, and trial terms are shown on our pricing page and at checkout.</li>
        <li>Fees are billed in advance, are non-refundable except where required by law, and renew automatically until cancelled.</li>
        <li>You may cancel from your account settings; cancellation takes effect at the end of the current billing period.</li>
        <li>We may change prices on 30 days' notice; changes take effect at your next renewal.</li>
      </ul>

      <h2>3. Acceptable use</h2>
      <p>You agree not to:</p>
      <ul>
        <li>Use the Service to violate any law or third-party right.</li>
        <li>Send spam, unsolicited marketing, or content that violates CAN-SPAM, TCPA, or similar laws.</li>
        <li>Reverse-engineer, scrape, or attempt to bypass rate limits or security controls.</li>
        <li>Upload malware or interfere with other customers' use of the Service.</li>
        <li>Use the Service to make decisions that have legal or similarly significant effects on individuals without human review.</li>
      </ul>

      <h2>4. Customer data &amp; PHI</h2>
      <p>
        You retain all rights to data you submit ("Customer Data"). You grant
        us a limited license to host, process, and display Customer Data solely
        to provide the Service. If Customer Data includes Protected Health
        Information, our Business Associate Agreement governs that handling.
        See our <a href="/hipaa">HIPAA Notice</a>.
      </p>

      <h2>5. AI-generated content</h2>
      <p>
        The Service uses AI to suggest emails, score leads, and enrich data.
        Output may be inaccurate. You are responsible for reviewing AI output
        before sending or acting on it. We do not warrant that AI-generated
        content is fit for any particular purpose.
      </p>

      <h2>6. Intellectual property</h2>
      <p>
        We own the Service, including all software, designs, and trademarks.
        Feedback you give us may be used without restriction or compensation.
      </p>

      <h2>7. Suspension &amp; termination</h2>
      <p>
        We may suspend or terminate your account for material breach,
        non-payment, or to comply with law. On termination you may export your
        data for 30 days; after that we may delete it.
      </p>

      <h2>8. Disclaimers</h2>
      <p>
        THE SERVICE IS PROVIDED "AS IS" WITHOUT WARRANTIES OF ANY KIND, EXPRESS
        OR IMPLIED, INCLUDING MERCHANTABILITY, FITNESS FOR A PARTICULAR
        PURPOSE, AND NON-INFRINGEMENT.
      </p>

      <h2>9. Limitation of liability</h2>
      <p>
        TO THE MAXIMUM EXTENT PERMITTED BY LAW, OUR AGGREGATE LIABILITY ARISING
        FROM OR RELATED TO THESE TERMS WILL NOT EXCEED THE FEES YOU PAID IN THE
        12 MONTHS BEFORE THE EVENT GIVING RISE TO LIABILITY. WE WILL NOT BE
        LIABLE FOR INDIRECT, INCIDENTAL, SPECIAL, OR CONSEQUENTIAL DAMAGES.
      </p>

      <h2>10. Indemnification</h2>
      <p>
        You will defend and indemnify us against claims arising from your
        Customer Data, your use of the Service in violation of these Terms, or
        your violation of law.
      </p>

      <h2>11. Governing law &amp; disputes</h2>
      <p>
        These Terms are governed by the laws of the Commonwealth of Virginia,
        without regard to conflict-of-laws principles. Disputes will be
        resolved exclusively in the state or federal courts located in
        Virginia, and you consent to that jurisdiction. Either party may seek
        injunctive relief in any court of competent jurisdiction.
      </p>

      <h2>12. Changes</h2>
      <p>
        We may update these Terms; material changes will be announced in-app or
        by email at least 14 days before they take effect. Continued use after
        the effective date constitutes acceptance.
      </p>

      <h2>13. Contact</h2>
      <p>
        H&amp;E Associates LLC —{" "}
        <a href="mailto:legal@legacygrowthengine.com">legal@legacygrowthengine.com</a>
      </p>
    </LegalLayout>
  );
}